import React from "react";
import Topbar from "./topbar/Topbar";
import Footer from "./footer/Footer";
import {
  MainContainer,
  PrimaryContainer,
  ResponsiveContainer,
} from "./welcome/Welcome";
import {
  TextVariant,
  TypographyNew,
} from "../product/global/typography/typography";
import { getStaticImage } from "../product/utils/static";
import styled, { useTheme } from "styled-components";

const CenterC = styled(PrimaryContainer)`
  margin: auto;
  justify-content: center;
  align-items: center;
  height: 300px;
  display: flex;
  flex-wrap: nowrap;
  padding: 10em 0 0 0;
`;
const PageReworking = (): JSX.Element => {
  const theme = useTheme();
  return (
    <>
      <Topbar />
      <MainContainer>
        <ResponsiveContainer>
          <CenterC>
            <div>
              <img
                src={getStaticImage("WorkInProgress.png")}
                alt={"Work In Progress"}
                height={"300em"}
              />
            </div>
            <div>
              <TypographyNew
                variant={TextVariant.subtitle2}
                color={theme.colors.grays1}
              >
                Die Website wird aktuell überarbeitet...
              </TypographyNew>
            </div>
          </CenterC>
        </ResponsiveContainer>
      </MainContainer>
      <Footer />
    </>
  );
};

export default PageReworking;
